// src/components/PayPalUSDWrapper.js
import React from 'react';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

// ✅ OLD CREDENTIALS - WORKS
const SANDBOX_CLIENT_ID = "AewbCarh7Wot_CinXeiX5S5bryMFKHtZFTX2njC2MV_zMRg2abc3q0RREeJSjZauKneKH3u-URGSzICg";
const LIVE_CLIENT_ID = "AT4I2oDRHsk1MTa9yUFHhp4ChqoUDWWiIKtW6Dx6LA-Df7RyVtCn2zZA3dC4ftq6wVwXtx4525SaY5Ij";

// ✅ NEW CREDENTIALS - LOCALE ERROR
// const SANDBOX_CLIENT_ID = "AQ5WWRK0kxsrfcqUvHe-snPRiGJtMKwEXNNm5N3fU8MR3X3X0fs5JoCbKHt094vb3E_VlFfjfZf7r0Y4";
// const LIVE_CLIENT_ID = "AfDnXrP_0qiNxmmiC1EPdBKnY4whmCTwfZGC8VKaKBqxlujpvR77tckA1dyk4PQPUyL-F-Ewx739Ca16";


// ✅ AUTO-DETECT ENVIRONMENT
const getPayPalConfig = () => {
  const isLocalhost = window.location.hostname === 'localhost';
  const isVercelApp = window.location.hostname.includes('.vercel.app');
  const isProductionDomain = window.location.hostname === 'king-solarman-frontend.vercel.app' || 
                            window.location.hostname === 'king-solarman.com'; // Add your real domain
  
  const baseConfig = {
    currency: "USD",
    intent: "capture",
    "enable-funding": "paylater,venmo,card",
    "disable-funding": "",
    "locale": "en_US", // Force US English locale
    "buyer-country": "US", // Set buyer country to US
    "components": "buttons", // Only load buttons component
    "debug": false // Disable debug mode in production
  };

  // Use Sandbox ONLY for localhost
  // Use Live for your production Vercel domain and real domain
  if (isLocalhost) {
    console.log('🔧 PayPal Mode: SANDBOX (Local Development)');
    return {
      "client-id": SANDBOX_CLIENT_ID,
      currency: "USD",
      intent: "capture",
      "enable-funding": "paylater,venmo,card",
      "disable-funding": "",
    };

  } else if (isVercelApp || isProductionDomain) {
    console.log('🚀 PayPal Mode: LIVE (Production)');
    return {
      "client-id": LIVE_CLIENT_ID,
      currency: "USD",
      intent: "capture",
      "enable-funding": "paylater,venmo,card", 
      "disable-funding": "",
    };
  } else {
    // Default to sandbox for any other domains (safety first)
    console.log('🔧 PayPal Mode: SANDBOX (Unknown Domain - Safety Default)');
    return {
      "client-id": SANDBOX_CLIENT_ID,
      currency: "USD",
      intent: "capture",
      "enable-funding": "paylater,venmo,card",
      "disable-funding": "",
    };
  }
};


export default function PayPalUSDWrapper({ children }) {
  const paypalOptions = getPayPalConfig();
  
  return (
    <PayPalScriptProvider 
      options={paypalOptions}
      deferLoading={false}
    >
      {children}
    </PayPalScriptProvider>
  );
}
